import { HOUSING_STATUS_OPTIONS, ID_TYPE_OPTIONS, PHONE_TYPE_OPTIONS, SUFFIX_OPTIONS } from '../constants/form-options';

export const getHousingTypeLabel = (value: string) => {
  const option = HOUSING_STATUS_OPTIONS.find((option) => option.value === value);
  return option ? option.label : value;
};

export const getIdTypeLabel = (value: string) => {
  const option = ID_TYPE_OPTIONS.find((option) => option.value === value);
  return option ? option.label : value;
};

export const getPhoneTypeLabel = (value: string) => {
  const option = PHONE_TYPE_OPTIONS.find((option) => option.value === value);
  return option ? option.label : value;
};

export const getSuffixLabel = (value: string) => {
  const option = SUFFIX_OPTIONS.find((option) => option.value === value);
  return option ? option.label : value;
};
